import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DollarOutlinedSvg from "@ant-design/icons-svg/es/asn/DollarOutlined";
import AntdIcon from "../components/AntdIcon";
var DollarOutlined = function DollarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DollarOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DollarOutlined.displayName = 'DollarOutlined';
}
export default /*#__PURE__*/React.forwardRef(DollarOutlined);